"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Globe } from "lucide-react";

export default function LanguageSwitch() {
  const pathname = usePathname() || "/";
  const isEn = pathname === "/en" || pathname.startsWith("/en/");

  // Compute DE destination
  let deHref = "/";
  if (pathname === "/en") {
    deHref = "/";
  } else if (pathname.startsWith("/en/")) {
    deHref = pathname.replace(/^\/en/, "") || "/";
  } else {
    deHref = pathname;
  }

  // Compute EN destination
  let enHref = "/en";
  if (pathname === "/") {
    enHref = "/en";
  } else if (pathname === "/en" || pathname.startsWith("/en/")) {
    enHref = pathname;
  } else {
    enHref = `/en${pathname}`;
  }

  return (
    <div
      role="group"
      aria-label="Language selection"
      className="inline-flex items-center gap-1 rounded-full border border-black/10 bg-black/[0.04] p-0.5 text-xs font-semibold backdrop-blur-xs transition-colors dark:border-white/10 dark:bg-white/[0.06]"
    >
      <Globe className="ml-1.5 h-3.5 w-3.5 text-neutral-500 dark:text-neutral-400" aria-hidden="true" />
      <Link
        href={deHref}
        className={`rounded-full px-2 py-0.5 transition-all cursor-pointer ${
          !isEn
            ? "bg-white text-black shadow-xs font-bold dark:bg-neutral-800 dark:text-white"
            : "text-neutral-600 hover:text-black dark:text-neutral-400 dark:hover:text-white"
        }`}
        aria-label="Auf Deutsch umschalten"
        aria-current={!isEn ? "true" : undefined}
      >
        DE
      </Link>
      <Link
        href={enHref}
        className={`rounded-full px-2 py-0.5 transition-all cursor-pointer ${
          isEn
            ? "bg-white text-black shadow-xs font-bold dark:bg-neutral-800 dark:text-white"
            : "text-neutral-600 hover:text-black dark:text-neutral-400 dark:hover:text-white"
        }`}
        aria-label="Switch to English"
        aria-current={isEn ? "true" : undefined}
      >
        EN
      </Link>
    </div>
  );
}
